export default __webpack_public_path__ + "15c36d00f8db22ae483e73ca9b665ad5.png";